module.exports = __webpack_public_path__ + "img/director-tiao-icon3.48856c16.png";